import { OptionTypes } from '@/types';
import { Box, Grid2, Typography, useMediaQuery } from '@mui/material';
import car1 from 'assets/icons/car1.svg';
import { Option } from 'components';
import { useBookingTimer } from 'context/BookingTimerContext';
import {
  initialUserSearchState,
  useUserSearchContext,
} from 'context/UserSearchContext';
import * as React from 'react';
import { CONSTANT_TEXT } from 'services/dummy';

export const Home: React.FC<{ locationCode: string }> = ({ locationCode }) => {
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const { bookingSearchData, setBookingSearchData, loading } =
    useUserSearchContext();
  const { startTimer } = useBookingTimer();
  const dailyWeekly: OptionTypes = {
    name: 'Daily / Weekly Rental',
    icon: car1,
    btnName: 'Book Now',
    unitCode: 'spot-rental',
  };
  React.useEffect(() => {
    if (bookingSearchData && bookingSearchData.OutDetails.BranchId) {
      setBookingSearchData({ ...initialUserSearchState });
      startTimer(0);
    }
  }, [bookingSearchData]);
  return (
    <Grid2
      container
      direction="column"
      spacing={2}
      sx={{
        position: 'fixed',
        top: '65px',
        bottom: '100px',
        left: '0px',
        right: '0px',
        overflow: 'hidden',
      }}
    >
      {/* Image Section */}
      <Grid2
        size={{ xs: 12 }}
        sx={{ flex: 1, overflow: 'hidden', height: '40%', flexShrink: 0 }}
      >
        <img
          src="https://webfiles.thriftyuae.com/prod-blob/assets/home-page-banner.jpg"
          alt="Hero banner"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Grid2>

      {/* Content Section */}
      <Grid2
        size={{ xs: 12 }}
        sx={{
          '@media (orientation: portrait)': {
            display: 'flex',
            height: 'calc(100vh - 50vh)',
            alignItems: 'center',
          },
          flex: 1,
          overflow: 'hidden',
        }}
        className="actionSection"
        textAlign="center"
      >
        <Typography variant="h2" gutterBottom className={`homeTitle`}>
          {CONSTANT_TEXT.homeText}
        </Typography>
        <Option
          name={dailyWeekly.name}
          icon={dailyWeekly.icon}
          unitCode={dailyWeekly.unitCode}
          btnName={dailyWeekly.btnName}
          locationCode={locationCode}
        />
      </Grid2>
    </Grid2>
  );
};
